module.exports = __webpack_public_path__ + "static/media/СЗФО_2000.6ac5c9ca.png";